module.exports = __webpack_public_path__ + "img/zhengshu6.78b8e2e4.png";